import { ContractWithLinks } from 'common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchContracts } from './ContractsSlice';
import { ContractsDataSelector } from './ContractsDataSelector';

export function useContracts(): AbstractDataState<ContractWithLinks[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchContracts, ContractsDataSelector);
}
